import { render, staticRenderFns } from "./textarea-tertiary.vue?vue&type=template&id=c140b80e&scoped=true&"
import script from "./textarea-tertiary.vue?vue&type=script&lang=js&"
export * from "./textarea-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c140b80e",
  null
  
)

export default component.exports